import React from 'react';
import { Link } from 'react-router-dom';
import { LinkedinIcon, InstagramIcon, FacebookIcon, YoutubeIcon } from 'lucide-react';
import { useTranslation } from '../../lib/i18n';
// TikTok icon (not in lucide-react)
function TikTokIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-292">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.75a4.85 4.85 0 0 1-1.01-.06z" data-id="element-293" />
    </svg>;
}
export function Footer() {
  const {
    t,
    lang
  } = useTranslation();
  const socials = [{
    href: 'https://linkedin.com',
    icon: LinkedinIcon,
    label: 'LinkedIn'
  }, {
    href: 'https://instagram.com',
    icon: InstagramIcon,
    label: 'Instagram'
  }, {
    href: 'https://facebook.com',
    icon: FacebookIcon,
    label: 'Facebook'
  }, {
    href: 'https://tiktok.com',
    icon: TikTokIcon,
    label: 'TikTok'
  }, {
    href: 'https://youtube.com',
    icon: YoutubeIcon,
    label: 'YouTube'
  }];
  return <footer className="bg-dark-surface border-t-2 border-dark-border mt-auto" data-id="element-294">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-295">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-296">
          <div data-id="element-297">
            <img src="https://cdn.magicpatterns.com/uploads/wGduMkj3cFFyWsuhxML9qE/LOGO_1.jpg" alt="D-TECH Solutions" className="h-10 w-auto mb-4" data-id="element-298" />
            <p className="text-gray-400 text-sm leading-relaxed mb-5" data-id="element-299">
              {lang === 'en' ? 'Electric machines for safe cargo transport in multi-story buildings.' : 'Električne mašine za bezbedan transport tereta u višespratnim objektima.'}
            </p>
            <div className="flex items-center gap-3" data-id="element-300">
              {socials.map(({
              href,
              icon: Icon,
              label
            }) => <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className="w-8 h-8 flex items-center justify-center rounded text-gray-400 hover:text-brand-yellow transition-colors" data-id="element-301">
                  <Icon className="w-4 h-4" data-id="element-302" />
                </a>)}
            </div>
          </div>
          <div data-id="element-303">
            <h3 className="text-white font-bold mb-4" data-id="element-304">{t.footer.products}</h3>
            <ul className="space-y-2" data-id="element-305">
              <li data-id="element-306">
                <Link to="/products/standard" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-307">
                  D-TECH STANDARD SC-B
                </Link>
              </li>
              <li data-id="element-308">
                <Link to="/products/atlas" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-309">
                  D-TECH STANDARD+ SC-B
                </Link>
              </li>
              <li data-id="element-310">
                <Link to="/products/raptor" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-311">
                  D-TECH RAPTOR SC-B
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-312">
            <h3 className="text-white font-bold mb-4" data-id="element-313">{t.footer.company}</h3>
            <ul className="space-y-2" data-id="element-314">
              <li data-id="element-315">
                <Link to="/about" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-316">
                  {t.footer.about}
                </Link>
              </li>
              <li data-id="element-317">
                <Link to="/contact" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-318">
                  {t.footer.contact}
                </Link>
              </li>
              <li data-id="element-319">
                <Link to="/legal" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-320">
                  {t.footer.legal}
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-dark-border pt-8 text-center" data-id="element-321">
          <p className="text-gray-500 text-sm" data-id="element-322">
            © {new Date().getFullYear()} D-TECH Solutions. {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>;
}